module.exports = __webpack_public_path__ + "img/Picture4.87c6d881.png";